import { Box, Grid, Typography } from '@mui/material';
import FunnelProgressBar, { formatFunnelPercent } from './FunnelProgressBar';
import { normalizeMetric } from '../utils/metricFormatters';

const JOURNEY_STAGES = [
  { name: 'App Installs', key: 'appInstalls' },
  { name: 'Started Application', key: 'startedApplication' },
  { name: 'Completed Interview', key: 'completedInterview' },
  { name: 'Approved', key: 'approved' },
  { name: 'Paid Membership', key: 'paidMembership' },
  { name: 'Booked First Event', key: 'bookedFirstEvent' },
  { name: 'Retained Day 7', key: 'retainedDay7' },
];

const VettingJourney = ({ metrics }) => {
  const journey = metrics?.vettingJourney ?? {};

  const journeyData = JOURNEY_STAGES.map((stage) => {
    const stageData = normalizeMetric(journey[stage.key]) || {
      count: 0,
      percentage: 0,
    };

    return {
      name: `${stage.name} (${stageData.count})`,
      percentage: Number(stageData.percentage) || 0,
    };
  });

  return (
    <Box sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'medium' }}>
          Vetting Journey
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          Install → Application → Approval → Payment → First Booking (Activation) → Retention
        </Typography>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          mt: 2,
        }}
      >
        {journeyData.map((stage) => (
          <Grid container key={stage.name} alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={8}>
              <FunnelProgressBar value={stage.percentage} formatLabel={formatFunnelPercent} />
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ fontSize: 14 }}>{stage.name}</Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

export default VettingJourney;
